import _regenerator from "/usr/app/node_modules/@babel/runtime/helpers/esm/regenerator.js";
import _asyncToGenerator from "/usr/app/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _toConsumableArray from "/usr/app/node_modules/@babel/runtime/helpers/esm/toConsumableArray.js";
import _objectSpread from "/usr/app/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
var __jsx = React.createElement;
import React, { createContext, useContext, useReducer, useState, useEffect, useRef } from "react";
import loadable from "@loadable/component";
import { api__loginOrSignup, api__logoutUser, api__togglePostToFavorite, api__updateUserCityProfile, api__updateUserMobileProfile, api__updateUserNameProfile } from "@/apis/customer/customer";
import { parseJsonSafely } from "@/utils/GlobalJavascriptFunction";
import { cookie__setAccessToken, cookie__setUserId } from "@/_MiniApps/auth/cookiesHelpers";
import useHelpers from "@hooks/useHelpers";
import API__getSearchHistory from "@/apis/searchHistory/API__getSearchHistory";
import API__UpdateSearchHistory from "@/apis/searchHistory/UpdateAskingPrice";
import useLocalStorage from "@hooks/useLocalStorage";
import { api__saveSearch } from "@/apis/saved-search/api__saveSearch";
import { api__listFavouriteIds } from "@/apis/customer/list-favourite";
import { api__getSavedSearchList } from "@/apis/saved-search/api__getSavedSearchList";
import useIsWebView from "@hooks/useIsWebview";
import useWebView from "@hooks/useWebview";
var fallback = {
  fallback: null
};
export var AuthPopUpV2 = loadable({
  resolved: {},
  chunkName: function chunkName() {
    return "_MiniApps-auth-ui-AuthPopupV2-AuthPopupV2";
  },
  isReady: function isReady(props) {
    var key = this.resolve(props);
    if (this.resolved[key] !== true) {
      return false;
    }
    if (typeof __webpack_modules__ !== 'undefined') {
      return !!__webpack_modules__[key];
    }
    return false;
  },
  importAsync: function importAsync() {
    return import(/* webpackChunkName: "_MiniApps-auth-ui-AuthPopupV2-AuthPopupV2" */"@/_MiniApps/auth/ui/AuthPopupV2/AuthPopupV2");
  },
  requireAsync: function requireAsync(props) {
    var _this = this;
    var key = this.resolve(props);
    this.resolved[key] = false;
    return this.importAsync(props).then(function (resolved) {
      _this.resolved[key] = true;
      return resolved;
    });
  },
  requireSync: function requireSync(props) {
    var id = this.resolve(props);
    if (typeof __webpack_require__ !== 'undefined') {
      return __webpack_require__(id);
    }
    return eval('module.require')(id);
  },
  resolve: function resolve() {
    if (require.resolveWeak) {
      return require.resolveWeak("@/_MiniApps/auth/ui/AuthPopupV2/AuthPopupV2");
    }
    return eval('require.resolve')("@/_MiniApps/auth/ui/AuthPopupV2/AuthPopupV2");
  }
}, fallback);
var _useLocalStorage = useLocalStorage(),
  getLocalStorage = _useLocalStorage.getLocalStorage,
  setLocalStorage = _useLocalStorage.setLocalStorage,
  removeLocalStorage = _useLocalStorage.removeLocalStorage;

// Define types

// Define initial state and reducer function
var DEFAULT_INITIAL_STATE = {
  user: null,
  favorites: [],
  userJson: null,
  isLoggedIn: false,
  isLoading: false,
  hasAccount: null,
  search_hashes: []
};

// Reducer function to handle authentication state transitions
function authReducer(state, action) {
  switch (action.type) {
    case "SET_ALL_FAVORITES":
      state = _objectSpread(_objectSpread({}, state), {}, {
        favorites: action.payload
      });
      if (__IS_CSR__) {
        var _state;
        setLocalStorage("favorites", JSON.stringify(((_state = state) === null || _state === void 0 ? void 0 : _state.favorites) || []));
      }
      return state;
    case "SET_FAVORITE":
      state = _objectSpread(_objectSpread({}, state), {}, {
        favorites: action.payload.isAddOperation ? [].concat(_toConsumableArray(state.favorites), [action.payload.post_id]) : state.favorites.filter(function (id) {
          return id !== action.payload.post_id;
        })
      });
      if (__IS_CSR__) {
        var _state2;
        setLocalStorage("favorites", JSON.stringify(((_state2 = state) === null || _state2 === void 0 ? void 0 : _state2.favorites) || []));
      }
      return state;
    case "SET_USER_DATA":
      state = _objectSpread(_objectSpread({}, state), {}, {
        user: action.payload,
        isLoggedIn: true,
        isLoading: false,
        userJson: null
      });
      if (__IS_CSR__) {
        var _action$payload, _action$payload2;
        setLocalStorage("user", JSON.stringify(state.user));
        if (action !== null && action !== void 0 && (_action$payload = action.payload) !== null && _action$payload !== void 0 && _action$payload.favorites && Array.isArray(action === null || action === void 0 ? void 0 : (_action$payload2 = action.payload) === null || _action$payload2 === void 0 ? void 0 : _action$payload2.favorites)) {
          var _action$payload3;
          setLocalStorage("favorites", JSON.stringify((action === null || action === void 0 ? void 0 : (_action$payload3 = action.payload) === null || _action$payload3 === void 0 ? void 0 : _action$payload3.favorites) || []));
        }
      }
      return state;
    case "LOGIN_SUCCESS":
      state = _objectSpread(_objectSpread({}, state), {}, {
        user: action.payload,
        isLoggedIn: true,
        isLoading: false
      });
      if (__IS_CSR__) {
        var _action$payload4, _action$payload6;
        setLocalStorage("user", JSON.stringify(_objectSpread(_objectSpread({}, action === null || action === void 0 ? void 0 : action.payload), {}, {
          favorites: -1,
          search_hashes: -1
        })));
        if (Array.isArray(action === null || action === void 0 ? void 0 : (_action$payload4 = action.payload) === null || _action$payload4 === void 0 ? void 0 : _action$payload4.favorites)) {
          var _action$payload5;
          setLocalStorage("favorites", JSON.stringify(action === null || action === void 0 ? void 0 : (_action$payload5 = action.payload) === null || _action$payload5 === void 0 ? void 0 : _action$payload5.favorites));
        }
        if (Array.isArray(action === null || action === void 0 ? void 0 : (_action$payload6 = action.payload) === null || _action$payload6 === void 0 ? void 0 : _action$payload6.search_hashes)) {
          setLocalStorage("search_hashes", JSON.stringify(action === null || action === void 0 ? void 0 : action.payload.search_hashes));
        }
        cookie__setAccessToken(action === null || action === void 0 ? void 0 : action.payload.token);
        cookie__setUserId(action === null || action === void 0 ? void 0 : action.payload.id);
      }
      return state;
    case "LOGOUT":
      state = _objectSpread(_objectSpread({}, state), {}, {
        user: null,
        isLoggedIn: false,
        isLoading: false,
        hasAccount: null
      });
      if (__IS_CSR__) {
        cookie__setAccessToken(null);
        cookie__setUserId(null);
        removeLocalStorage("user");
        removeLocalStorage("favorites");
        removeLocalStorage("search_hashes");
      }
      return state;
    case "LOADING":
      return _objectSpread(_objectSpread({}, state), {}, {
        isLoading: true
      });
    case "SET_HAS_ACCOUNT":
      state = _objectSpread(_objectSpread({}, state), {}, {
        hasAccount: action.payload,
        isLoading: false
      });
      return state;
    case "SET_ALL_SEARCH_HASHES":
      state = _objectSpread(_objectSpread({}, state), {}, {
        user: _objectSpread(_objectSpread({}, state.user), {}, {
          search_hashes: action.payload
        })
      });
      if (__IS_CSR__) {
        setLocalStorage("search_hashes", JSON.stringify((action === null || action === void 0 ? void 0 : action.payload) || []));
      }
      return state;
    case "SAVE_SEARCH":
      state = _objectSpread(_objectSpread({}, state), {}, {
        search_hashes: _toConsumableArray(action === null || action === void 0 ? void 0 : action.payload)
      });
      if (__IS_CSR__) {
        setLocalStorage("search_hashes", JSON.stringify(_toConsumableArray(state.search_hashes)));
      }
      return state;
    case "UPDATE_ALL_SEARCH_HASHES":
      state = _objectSpread(_objectSpread({}, state), {}, {
        search_hashes: action.payload
      });
      if (__IS_CSR__) {
        setLocalStorage("search_hashes", JSON.stringify(action.payload));
      }
      return state;
    default:
      return state;
  }
}
var getUserJsonFromUrl = function getUserJsonFromUrl() {
  if (__IS_SSR__) return null;
  var userData = parseJsonSafely(new URLSearchParams(location.search).get("user"));
  return userData;
};
var getInitialState = function getInitialState() {
  var userData = null;
  var favorites = [];
  var search_hashes = [];
  if (__IS_CSR__) {
    var _userData, _userData2, _userData3;
    userData = parseJsonSafely(getLocalStorage("user"));
    favorites = parseJsonSafely(getLocalStorage("favorites"), Array.isArray((_userData = userData) === null || _userData === void 0 ? void 0 : _userData.favorites) ? (_userData2 = userData) === null || _userData2 === void 0 ? void 0 : _userData2.favorites : []);
    favorites = Array.isArray(favorites) ? favorites : [];
    search_hashes = parseJsonSafely(getLocalStorage("search_hashes"), ((_userData3 = userData) === null || _userData3 === void 0 ? void 0 : _userData3.search_hashes) || []);
  }
  var isLoggedIn = !!userData;
  return _objectSpread(_objectSpread({}, DEFAULT_INITIAL_STATE), {}, {
    user: userData,
    userJson: getUserJsonFromUrl(),
    favorites: favorites,
    isLoggedIn: isLoggedIn,
    hasAccount: isLoggedIn ? true : null,
    search_hashes: search_hashes
  });
};

// Create AuthContext
var AuthContext = /*#__PURE__*/createContext(undefined);

// AuthProvider component that provides authentication context to its children
export var AuthProvider = function AuthProvider(_ref) {
  var children = _ref.children;
  var initialState = getInitialState();
  var isWebView = useIsWebView();
  var webview = useWebView();
  var _useReducer = useReducer(authReducer, initialState),
    state = _useReducer[0],
    dispatch = _useReducer[1];
  var SEARCH_HISTORY_LOCAL_STORAGE_KEY = "searchHistory";

  //const [pendingAction, setPendingAction] = useState<PendingActionFunc | null>(null);
  var pendingAction = useRef();
  var setPendingAction = function setPendingAction(action) {
    pendingAction.current = action;
  };
  var _useHelpers = useHelpers(),
    navigateToHard = _useHelpers.navigateToHard;
  var _exposePublicApi = function _exposePublicApi() {
    window.__authContext__DONT_USE_ME_OR_YOU_WILL_BE_FIRED = {
      reAuth: reAuth
    };
  };
  useEffect(_exposePublicApi, []);
  useEffect(function () {
    if (state.isLoggedIn) {
      setTimeout(function () {
        updateSearchsWithApi();
      }, 0);
    }
  }, [state.isLoggedIn]);
  useEffect(function () {
    var favLocalStorage = parseJsonSafely(getLocalStorage("favorites"));
    if (state.isLoggedIn && !Array.isArray(favLocalStorage)) {
      remote_listFavourite().then(function () {
        console.log("remote_listFavourite done");
      });
    }
    var savedSearchLocalStorage = parseJsonSafely(getLocalStorage("search_hashes"));
    if (state.isLoggedIn && !Array.isArray(savedSearchLocalStorage)) {
      remote_getSavedSearchList().then(function () {
        console.log('remote_updateSearchHashes done');
      });
    }
  }, []);
  var getSearchHistoryFromLocalStorage = function getSearchHistoryFromLocalStorage() {
    var searchHistory = parseJsonSafely(getLocalStorage("searchHistory")) || [];
    return searchHistory;
  };
  var remote_saveSearchHistory = /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee(searchData) {
      var _searchData$result_co;
      var validSearchData, existingSearches, updatedSearches;
      return _regenerator().w(function (_context) {
        while (1) switch (_context.n) {
          case 0:
            // Ensure result_count is provided
            validSearchData = _objectSpread(_objectSpread({}, searchData), {}, {
              result_count: (_searchData$result_co = searchData.result_count) !== null && _searchData$result_co !== void 0 ? _searchData$result_co : 0 // Default to 0 if undefined
            }); // Always update local storage
            existingSearches = parseJsonSafely(getLocalStorage(SEARCH_HISTORY_LOCAL_STORAGE_KEY)) || []; // Add the new search at the beginning while ensuring uniqueness
            updatedSearches = [validSearchData].concat(_toConsumableArray(existingSearches.filter(function (item) {
              return item.text !== validSearchData.text;
            })));
            setLocalStorage(SEARCH_HISTORY_LOCAL_STORAGE_KEY, JSON.stringify(updatedSearches));

            // If logged in, also update API
            if (state.isLoggedIn) {
              updateSearchsWithApi();
            }
          case 1:
            return _context.a(2);
        }
      }, _callee);
    }));
    return function remote_saveSearchHistory(_x) {
      return _ref2.apply(this, arguments);
    };
  }();
  var updateSearchsWithApi = function updateSearchsWithApi() {
    var searchHistory = getSearchHistoryFromLocalStorage();
    var lastSyncedSearchHistory = parseJsonSafely(getLocalStorage("LAST_SYNCED_SEARCH_HISTORY")) || [];

    // Extract only the `text` values from search history
    var currentTexts = searchHistory.map(function (item) {
      return item.text;
    });
    var lastSyncedTexts = new Set(lastSyncedSearchHistory.map(function (item) {
      return item.text;
    }));

    // Identify newly added searches
    var newSearches = searchHistory.filter(function (item) {
      return !lastSyncedTexts.has(item.text);
    });

    // If no new searches, skip the API update
    if (newSearches.length === 0) {
      console.log("No new searches added, skipping API sync.");
      return;
    }

    // Hit API only for newly added searches
    newSearches.forEach(function (searchData, idx) {
      API__UpdateSearchHistory(searchData).then(function () {
        if (newSearches.length - 1 === idx) {
          // Update last synced search history after successful sync
          setLocalStorage("LAST_SYNCED_SEARCH_HISTORY", JSON.stringify(searchHistory));
          removeLocalStorage(SEARCH_HISTORY_LOCAL_STORAGE_KEY);
          syncSearchHistoryOnLogin();
        }
      });
    });
  };
  var syncSearchHistoryOnLogin = /*#__PURE__*/function () {
    var _ref3 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2() {
      return _regenerator().w(function (_context2) {
        while (1) switch (_context2.n) {
          case 0:
            if (state.isLoggedIn) {
              API__getSearchHistory().then(function (response) {
                var _response$data;
                if (!response || response.status === 404 || response.length === 0) {
                  console.warn("No valid search history available from the API");
                  return;
                }
                // Merge local storage data with fetched data, ensuring no duplicates
                var mergedSearches = _toConsumableArray(new Map(_toConsumableArray(response === null || response === void 0 ? void 0 : (_response$data = response.data) === null || _response$data === void 0 ? void 0 : _response$data.data).map(function (item) {
                  return [item.text, item];
                })).values());
                // Update local storage with merged data
                setLocalStorage(SEARCH_HISTORY_LOCAL_STORAGE_KEY, JSON.stringify(mergedSearches));
              });
            }
          case 1:
            return _context2.a(2);
        }
      }, _callee2);
    }));
    return function syncSearchHistoryOnLogin() {
      return _ref3.apply(this, arguments);
    };
  }();
  var remote_listFavourite = /*#__PURE__*/function () {
    var _ref4 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee3() {
      return _regenerator().w(function (_context3) {
        while (1) switch (_context3.n) {
          case 0:
            return _context3.a(2, api__listFavouriteIds().then(function (post_ids) {
              dispatch({
                type: "SET_ALL_FAVORITES",
                payload: post_ids
              });
            }));
        }
      }, _callee3);
    }));
    return function remote_listFavourite() {
      return _ref4.apply(this, arguments);
    };
  }();
  var remote_updateUserCityProfile = /*#__PURE__*/function () {
    var _ref5 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee4(city_id) {
      return _regenerator().w(function (_context4) {
        while (1) switch (_context4.n) {
          case 0:
            return _context4.a(2, api__updateUserCityProfile(city_id).then(function (data) {
              setUserData(data);
            }));
        }
      }, _callee4);
    }));
    return function remote_updateUserCityProfile(_x2) {
      return _ref5.apply(this, arguments);
    };
  }();
  var remote_updateUserNameProfile = /*#__PURE__*/function () {
    var _ref6 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee5(name) {
      return _regenerator().w(function (_context5) {
        while (1) switch (_context5.n) {
          case 0:
            return _context5.a(2, api__updateUserNameProfile(name).then(function (data) {
              setUserData(data);
            }));
        }
      }, _callee5);
    }));
    return function remote_updateUserNameProfile(_x3) {
      return _ref6.apply(this, arguments);
    };
  }();
  var remote_updateUserMobileProfile = /*#__PURE__*/function () {
    var _ref7 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee6(mobile) {
      return _regenerator().w(function (_context6) {
        while (1) switch (_context6.n) {
          case 0:
            return _context6.a(2, api__updateUserMobileProfile(mobile).then(function (data) {
              setUserData(data);
            }));
        }
      }, _callee6);
    }));
    return function remote_updateUserMobileProfile(_x4) {
      return _ref7.apply(this, arguments);
    };
  }();
  var remote_togglePostToFavorite = /*#__PURE__*/function () {
    var _ref8 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee7(post_id) {
      return _regenerator().w(function (_context7) {
        while (1) switch (_context7.n) {
          case 0:
            return _context7.a(2, api__togglePostToFavorite(post_id).then(function (isAddOperation) {
              dispatch({
                type: "SET_FAVORITE",
                payload: {
                  post_id: post_id,
                  isAddOperation: isAddOperation
                }
              });
              return isAddOperation;
            }));
        }
      }, _callee7);
    }));
    return function remote_togglePostToFavorite(_x5) {
      return _ref8.apply(this, arguments);
    };
  }();
  var remote_saveSearch = /*#__PURE__*/function () {
    var _ref9 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee8(search_hash, title, path, tags) {
      return _regenerator().w(function (_context8) {
        while (1) switch (_context8.n) {
          case 0:
            return _context8.a(2, api__saveSearch({
              search_hash: search_hash,
              title: title,
              path: path,
              tags: tags
            }).then(function (res) {
              var _res$data;
              if ((res === null || res === void 0 ? void 0 : (_res$data = res.data) === null || _res$data === void 0 ? void 0 : _res$data.success) === true) {
                var _res$data2, _res$data2$data;
                var search_hashes = res === null || res === void 0 ? void 0 : (_res$data2 = res.data) === null || _res$data2 === void 0 ? void 0 : (_res$data2$data = _res$data2.data) === null || _res$data2$data === void 0 ? void 0 : _res$data2$data.map(function (item) {
                  return item === null || item === void 0 ? void 0 : item.search_hash;
                });
                dispatch({
                  type: "SAVE_SEARCH",
                  payload: search_hashes
                });
                return res;
              }
              return null;
            }));
        }
      }, _callee8);
    }));
    return function remote_saveSearch(_x6, _x7, _x8, _x9) {
      return _ref9.apply(this, arguments);
    };
  }();
  var remote_getSavedSearchList = /*#__PURE__*/function () {
    var _ref0 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee9() {
      return _regenerator().w(function (_context9) {
        while (1) switch (_context9.n) {
          case 0:
            return _context9.a(2, api__getSavedSearchList().then(function (data) {
              var search_hashes = data.map(function (item) {
                return item === null || item === void 0 ? void 0 : item.search_hash;
              });
              dispatch({
                type: "SET_ALL_SEARCH_HASHES",
                payload: search_hashes
              });
            }));
        }
      }, _callee9);
    }));
    return function remote_getSavedSearchList() {
      return _ref0.apply(this, arguments);
    };
  }();
  var remote_updateSearchHashes = /*#__PURE__*/function () {
    var _ref1 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee0(search_hashes) {
      return _regenerator().w(function (_context0) {
        while (1) switch (_context0.n) {
          case 0:
            dispatch({
              type: "UPDATE_ALL_SEARCH_HASHES",
              payload: search_hashes
            });
          case 1:
            return _context0.a(2);
        }
      }, _callee0);
    }));
    return function remote_updateSearchHashes(_x0) {
      return _ref1.apply(this, arguments);
    };
  }();
  var setUserData = function setUserData(userData) {
    userData.opt_whatsapp_interest = Number(userData.opt_whatsapp_interest) || 0;
    dispatch({
      type: "SET_USER_DATA",
      payload: userData
    });
    if (userData.favorites) {
      dispatch({
        type: "SET_ALL_FAVORITES",
        payload: userData.favorites
      });
    }
    if (userData.token) {
      // this place set toke inside cookied, should run before api call
      dispatch({
        type: "LOGIN_SUCCESS",
        payload: userData
      });
      cookie__setAccessToken(userData.token);
      cookie__setUserId(userData.id);
    }
    if (userData.search_hashes) {
      dispatch({
        type: "SET_ALL_SEARCH_HASHES",
        payload: userData.search_hashes
      });
    }
    if (state.hasAccount !== null) {
      userData.has_account = state.hasAccount;
    }
    runPendingAction(userData);
  };

  // Function to handle user logout
  var logout = /*#__PURE__*/function () {
    var _ref10 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee1() {
      var urlAfter,
        _args1 = arguments,
        _t;
      return _regenerator().w(function (_context1) {
        while (1) switch (_context1.p = _context1.n) {
          case 0:
            urlAfter = _args1.length > 0 && _args1[0] !== undefined ? _args1[0] : "/?ref=logout";
            dispatch({
              type: "LOADING"
            }); // Set loading state
            _context1.p = 1;
            _context1.n = 2;
            return api__logoutUser();
          case 2:
            // Call logout API
            dispatch({
              type: "LOGOUT"
            }); // Dispatch logout action
            _context1.n = 4;
            break;
          case 3:
            _context1.p = 3;
            _t = _context1.v;
            console.error("Logout failed", _t); // Handle logout failure
          case 4:
            removeLocalStorage(SEARCH_HISTORY_LOCAL_STORAGE_KEY);
            removeLocalStorage("recently_viewed_data"); // Clear local storage for recently_viewed_data

            if (urlAfter) {
              navigateToHard(urlAfter);
            }
          case 5:
            return _context1.a(2);
        }
      }, _callee1, null, [[1, 3]]);
    }));
    return function logout() {
      return _ref10.apply(this, arguments);
    };
  }();
  // Function to handle user logout
  var reAuth = /*#__PURE__*/function () {
    var _ref11 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee10() {
      return _regenerator().w(function (_context10) {
        while (1) switch (_context10.n) {
          case 0:
            if (!isWebView) {
              _context10.n = 1;
              break;
            }
            return _context10.a(2, webview.reAuth()["catch"](function () {
              console.log("webview reAuth failed");
              return logout();
            }));
          case 1:
            return _context10.a(2, logout());
        }
      }, _callee10);
    }));
    return function reAuth() {
      return _ref11.apply(this, arguments);
    };
  }();

  // Function to handle login or signup based on phone number
  var remote_loginOrSignup = /*#__PURE__*/function () {
    var _ref12 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee11(phoneNumber) {
      return _regenerator().w(function (_context11) {
        while (1) switch (_context11.n) {
          case 0:
            dispatch({
              type: "LOADING"
            }); // Set loading state
            _context11.n = 1;
            return api__loginOrSignup(phoneNumber).then(function (response) {
              var hasAccount = response.is_new_user === false;
              dispatch({
                type: "SET_HAS_ACCOUNT",
                payload: hasAccount
              }); // Set hasAccount based on response
            });
          case 1:
            return _context11.a(2);
        }
      }, _callee11);
    }));
    return function remote_loginOrSignup(_x1) {
      return _ref12.apply(this, arguments);
    };
  }();
  var runPendingAction = function runPendingAction(userData) {
    if (pendingAction !== null && pendingAction !== void 0 && pendingAction.current) {
      pendingAction.current(userData, true);
      setPendingAction(null);
    }
  };
  var isAuthInitialized = function isAuthInitialized() {
    return state.userJson === null;
  };
  useEffect(function () {
    if (state.userJson) {
      setUserData(state.userJson);
    }
  }, []);
  return /*#__PURE__*/React.createElement(AuthContext.Provider, {
    value: _objectSpread(_objectSpread({}, state), {}, {
      logout: logout,
      isAuthInitialized: isAuthInitialized,
      setUserData: setUserData,
      remote_loginOrSignup: remote_loginOrSignup,
      remote_updateUserCityProfile: remote_updateUserCityProfile,
      remote_updateUserNameProfile: remote_updateUserNameProfile,
      remote_updateUserMobileProfile: remote_updateUserMobileProfile,
      remote_togglePostToFavorite: remote_togglePostToFavorite,
      remote_saveSearchHistory: remote_saveSearchHistory,
      syncSearchHistoryOnLogin: syncSearchHistoryOnLogin,
      setPendingAction: setPendingAction,
      remote_saveSearch: remote_saveSearch,
      remote_updateSearchHashes: remote_updateSearchHashes,
      getSearchHistoryFromLocalStorage: getSearchHistoryFromLocalStorage
    })
  }, children);
};

// Custom hook for accessing AuthContext
export var useSession = function useSession() {
  var context = useContext(AuthContext);
  if (context === undefined) {
    throw new Error("useSession must be used within an AuthProvider"); // Ensure hook is used within provider
  }
  return context;
};

// Custom hook for accessing AuthContext
export var useAuthActions = function useAuthActions() {
  var context = useContext(AuthContext);
  if (context === undefined) {
    throw new Error("useAuthActions must be used within an AuthProvider"); // Ensure hook is used within provider
  }
  return context;
};
export var AuthPopupHOC = function AuthPopupHOC(_ref13) {
  var external_links = _ref13.external_links,
    authScreenDesign = _ref13.authScreenDesign,
    _ref13$modalDesign = _ref13.modalDesign,
    modalDesign = _ref13$modalDesign === void 0 ? {} : _ref13$modalDesign,
    _ref13$isSmallPopup = _ref13.isSmallPopup,
    isSmallPopup = _ref13$isSmallPopup === void 0 ? true : _ref13$isSmallPopup,
    renderFunc = _ref13.renderFunc,
    _ref13$onCancel = _ref13.onCancel,
    onCancel = _ref13$onCancel === void 0 ? null : _ref13$onCancel,
    _ref13$customModalCla = _ref13.customModalClassName,
    customModalClassName = _ref13$customModalCla === void 0 ? undefined : _ref13$customModalCla;
  var _useSession = useSession(),
    isLoggedIn = _useSession.isLoggedIn,
    user = _useSession.user;
  var _useAuthActions = useAuthActions(),
    setPendingAction = _useAuthActions.setPendingAction,
    setUserData = _useAuthActions.setUserData;
  var _useState = useState(false),
    showAuthPopUp = _useState[0],
    setShowAuthPopUp = _useState[1];
  // Function to check authentication status before performing an action
  var checkAuth = function checkAuth(action) {
    if (isLoggedIn) {
      // If user is logged in, perform the action immediately
      action(user, false);
    } else {
      // If not logged in, save the action and show the authentication popup
      setPendingAction(action);
      setShowAuthPopUp(true);
    }
  };
  var onSuccess = function onSuccess(userData) {
    setUserData(userData);
    setShowAuthPopUp(false);
  };
  var doWhenCancel = function doWhenCancel() {
    setShowAuthPopUp(false);
    if (onCancel) {
      onCancel();
    }
  };
  return /*#__PURE__*/React.createElement(React.Fragment, null, renderFunc(checkAuth), showAuthPopUp && /*#__PURE__*/React.createElement(AuthPopUpV2, {
    customModalClassName: customModalClassName,
    external_links: external_links,
    authScreenDesign: authScreenDesign,
    modalDesign: modalDesign,
    isSmallPopup: isSmallPopup,
    onSuccess: onSuccess,
    onCancel: doWhenCancel
  }));
};